import { List, ListItem, HStack, Text } from "@chakra-ui/react";
import type { PagesListProps } from "./PagesList.d";
import Dots from "./Dots";

const PagesList = ({ pages, onPageClick, currentPage }: PagesListProps) => (
  <HStack as={List} spacing="3px">
    {pages.map((item, idx) => {
      // eslint-disable-next-line react/no-array-index-key
      if (typeof item === "string") return <Dots key={item + idx} />;

      return (
        <ListItem
          cursor="pointer"
          w={{ base: 8, md: 10 }}
          h={{ base: 8, md: 10 }}
          display="flex"
          alignItems="center"
          justifyContent="center"
          rounded="md"
          onClick={() => onPageClick(item)}
          key={item}
          bg={currentPage === item ? "greyscale.300" : "none"}
          _hover={{ bg: "greyscale.200" }}
          data-testid={`pagination-item-${item}`}
        >
          <Text fontSize="sm" color="primary.500" fontWeight="medium">
            {item}
          </Text>
        </ListItem>
      );
    })}
  </HStack>
);

export default PagesList;
